import { FC } from 'react'
import { Checkbox, Progress } from '@wellesley/ui'
import { CircleCheck } from 'lucide-react'

import {
  type PollRowProps,
  type PollVoteRowProps,
  type PollResultRowProps,
} from './types'

const PollResultRow: FC<PollResultRowProps> = ({
  option,
  result,
  isUserVoted,
}) => (
  <div data-testid="poll-result-row" className="gap-xxxs flex flex-1 flex-col">
    <div className="gap-xxs flex items-center">
      <p className="mr-auto text-base">{option.title}</p>
      {isUserVoted && (
        <CircleCheck
          size={16}
          data-testid="checked-icon"
          color="var(--blue-500)"
        />
      )}
      <p className="text-base font-semibold">{result.toFixed(1)}%</p>
    </div>
    <Progress value={result} className="mt-xxs" />
  </div>
)

const PollVoteRow: FC<PollVoteRowProps> = ({
  option,
  isSelected,
  isSingleChoice,
  onVote,
}) => (
  <div
    data-testid="poll-vote-row"
    className="flex flex-1 cursor-pointer items-center justify-between"
    onClick={onVote}
  >
    <span>{option.title}</span>
    {!isSingleChoice && <Checkbox checked={isSelected} />}
  </div>
)

const PollRow: FC<PollRowProps> = (props) => (
  <div className="gap-xxs py-s rounded-m flex items-center justify-between border border-gray-300 px-[14px]">
    {props.canShowResult ? (
      <PollResultRow {...props} />
    ) : (
      <PollVoteRow {...props} />
    )}
  </div>
)

export default PollRow
